import { useEffect } from 'react';

import { LIVECHAT_GROUP_ID, LIVECHAT_LICENSE_ID } from '../../config';
import { ensureLiveChatWidget } from '../../lib/livechat';

/** Global vendor widget; LiveChat itself anchors the launcher to the viewport bottom-right. */
export default function LiveChatWidget() {
  useEffect(() => {
    ensureLiveChatWidget(LIVECHAT_LICENSE_ID, LIVECHAT_GROUP_ID);
  }, []);

  return null;
}
